var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"spinner-border spinner-border-sm"})
}
var staticRenderFns = []

export { render, staticRenderFns }